import React, {Component} from 'react'
import PropTypes from 'prop-types';
import Label from './label'

const styleSheet = {
    stress: {
        fontWeight: 'bold'
    },

};

const Accented = (props) => {
    let point = props.index === props.len ? '' : '.';
    return props.pos === props.index ? <span style={styleSheet.stress}>{props.syllable}{point}</span> :
        <span>{props.syllable}{point}</span>;
};


class Syllabic extends Component {

    render() {

        if (this.props.syllabic.length === 0) {
            return null
        }

        const pos = this.props.syllabic[0];
        let data = this.props.syllabic[1].split('.');
        const len = data.length - 1;

        return (

            <Label title="Divisão silábica: "
                   content=
                       {data.map((syllable, i) => (
                           <Accented pos={pos} index={i} len={len} syllable={syllable} key={i}/>

                       ))}>

            </Label>

        )
    }

}

Syllabic.propTypes = {
    syllabic: PropTypes.array.isRequired,
};

export default Syllabic


// WEBPACK FOOTER //
// ./src/syllabic.jsx